<template>
  <BarChart :height="400" :chart-data="data" :options="options"></BarChart>
</template>

<script>
import {Chart, registerables} from 'chart.js';

Chart.register(...registerables);
import {BarChart} from 'vue-chart-3';

export default {
  name: "ChamadosPorCliente",
  components: {
    BarChart
  },
  props: ['data'],
  setup() {
    const options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: false,
        title: {
          display: true,
          text: 'Chamados',
          align: 'start',
          font: {
            size: 20,
            weight: 'bold',
            lineHeight: 1.2,
          },
        },
        subtitle: {
          display: true,
          text: 'Por Clientes',
          align: 'start',
          padding: {
            bottom: 20
          }
        }
      },
    };
    return {options};
  }
}
</script>

<style>

</style>